import { useQuery } from 'react-query';

import { getTableColumns as queryFn } from 'api/endPoints/getTableColumns';

export const useQueryGetTableColumns = (params: { componentKey: string }) => {
    return useQuery<
        {
            columnOrder: string[];
            hiddenColumns: string[];
            componentKey: string;
        } | null,
        QueryError
    >(['getTableColumns', params], () => queryFn(params), {
        enabled: Boolean(params.componentKey),
        select: (response) => (Boolean(response) ? response : null),
    });
};
